import { SettingsField } from '../SettingsField'

import * as styles from './SettingsSwitchField.module.css'

function SettingsSwitchField({ labelClassName = styles.label, ...restProps }) {
  return <SettingsField {...restProps} labelClassName={labelClassName} />
}

export default SettingsSwitchField
